export default __webpack_public_path__ + "static/media/sites-mob5.7a072490.png";